module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate-new/header-image-mobile-02-9679cc659ccbc3c4252aa4e739a4f5e8.jpg";